import { Box, Link } from '@mui/material';

import Typography from '@/components/Typography';
import { spacing } from '@/constants/ui';

export const ThanksMessage = () => {
  const supportEmail = 'support@general-index.com';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: spacing['2']
      }}
    >
      <Typography
        size={32}
        sx={{
          fontWeight: 'bold'
        }}
      >
        Thank you!
      </Typography>
      <Typography
        size={32}
        sx={{
          fontWeight: 'bold'
        }}
      >
        You'll receive an email shortly.
      </Typography>
      <Typography size={20}>
        If you have any questions in the meantime, feel free to contact
        <br />
        <Link
          href={`mailto:${supportEmail}`}
          sx={{
            color: 'primary.main',
            cursor: 'pointer',
            textDecoration: 'underline'
          }}
        >
          {supportEmail}
        </Link>
      </Typography>
    </Box>
  );
};
